export default {
    jensekData: [],
    jegurData: [],
    jegurDataAll: [],
    jendikData: [],
    kecamData: [],
    kelurData: [],
    mapelData: [],
    paoneData: [],
    patwoData: [],
    tajarData: [],
    tajarAktif: null,
    tajarsNonAktif: [],
    eduData: [],
    tutamData: [],
    alarData: [],
    agamaData: [],
    stapegData: [],
    berkasData: [],
    kontakData: []
}